import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, setToken } from "@/lib/api";

export default function DemoAccess() {
  const { token } = useParams();
  const [error, setError] = useState("");

  useEffect(() => {
    api.post("/auth/demo-login", { token })
      .then(({ data }) => {
        setToken(data.access_token);
        window.location.replace("/");
      })
      .catch((e) => {
        const d = e?.response?.data?.detail;
        setError(typeof d === "string" ? d : "This demo link is no longer active");
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A2540] px-4">
      <div className="text-center" data-testid="demo-access-status">
        {error ? (
          <>
            <div className="font-display text-2xl font-semibold text-white">Demo link unavailable</div>
            <p className="text-sky-200 mt-2 text-sm">{error}</p>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-sky-400 mx-auto" />
            <div className="font-display text-xl font-semibold text-white mt-4">Opening the HTM Project Hub demo…</div>
          </>
        )}
      </div>
    </div>
  );
}
